import { computed, observable, toJS } from 'mobx';

export default class JobModel {
    id = null;
    @observable externalId = null;
    @observable type = null;
    @observable name = null;
    @observable instance = null;
    @observable status = null;
    @observable priority = null;
    @observable progress = null;

    @computed get priorityText() {
        switch (parseInt(this.priority, 10)) {
        case 0: return 'urgent';
        case 1: return 'high';
        case 2: return 'medium';
        case 3: return 'low';
        default: return 'unknown';
        }
    }

    constructor(id, externalId, type, name, instance, status, priority, progress) {
        this.id = id;
        this.externalId = externalId;
        this.type = type;
        this.name = name;
        this.instance = instance;
        this.status = status;
        this.priority = priority;
        this.progress = progress;
    }

    toJS() {
        toJS(this);
    }

    static fromJS(object) {
        return new JobModel(
            object.id, object.external_id, object.type, object.name, object.instance,
            object.status, object.priority, object.progress,
        );
    }
}
